module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.9782/images/homepage/company-logos-es/Nissan.svg"